/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC, ReactNode } from 'react';
import { Paragraph, Box, Button, Heading } from '@zillow/constellation-10';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';
import { ContentWrapper } from './components/ContentWrapper';
import { CatWrapper } from './components/CatWrapper';
import { StyledErrorPage } from './components/StyledErrorPage';
import { AsyncCat } from './components/AsyncCat';
import { StairsBackgroundSVG } from './components/StairsBackgroundSVG';

export const ErrorPage: FC<{
    homePageText?: ReactNode;
    homePageURL?: string;
    headingText: ReactNode;
    subHeadingText: ReactNode;
    additionalContent?: ReactNode;
    reportableError?: string | null;
}> = ({
    homePageText = 'Return to Zillow Home Loans',
    homePageURL = '/homeloans',
    headingText,
    subHeadingText,
    additionalContent,
    reportableError,
}) => (
    <StyledErrorPage>
        <StairsBackgroundSVG />
        <ContentWrapper>
            <Box
                css={{
                    maxWidth: '100%',
                    width: '{breakpoints.lg}',
                }}>
                <Heading
                    level={1}
                    fontFamily="heading-alt"
                    textStyle="responsive.heading-lg"
                    css={{ color: 'blue.500' }}>
                    {headingText}
                </Heading>
                <Heading
                    level={3}
                    textStyle="responsive.heading-sm"
                    fontFamily="heading"
                    css={{ marginTop: 'sm', color: 'blue.500' }}>
                    {subHeadingText}
                </Heading>
                {reportableError && (
                    <Paragraph css={{ marginTop: 'sm' }}>
                        When contacting our Customer Experience team, provide the following personalized code so they
                        can quickly identify and address your issue:&nbsp;
                        <Box asChild css={{ textWrap: 'nowrap' }}>
                            <strong>
                                <code>{reportableError}</code>
                            </strong>
                        </Box>
                    </Paragraph>
                )}
                <br />
                {homePageText && (
                    <Button
                        emphasis="filled"
                        css={{ marginTop: 'sm' }}
                        onClick={() => window.location.replace(new ZillowHomeLoansURL(homePageURL).resolvedURL)}>
                        {homePageText}
                    </Button>
                )}
                {additionalContent}
            </Box>
        </ContentWrapper>
        <CatWrapper>
            <AsyncCat />
        </CatWrapper>
    </StyledErrorPage>
);
